
function SdOrderAcceptHeaderCtrl($filter, TranslationService, StoreService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    this.ArrivalPoint = function () {
        if (!ctrl.order) {
            return '';
        }
        return ctrl.order.ArrivalPointID + ' ' + ctrl.order.ArrivalPointName;
    }

    this.isAcceptedOrRejected = function () {
        return StoreService.isAcceptedOrRejected(ctrl.order);        
    };

    this.isDisabled = function () {
        return StoreService.isAcceptedOrRejected(ctrl.order);
    };

    this.setAwaiting = function () {
        ctrl.sit_old = ctrl.order.sit_portal;
        ctrl.order.sit_portal = 4;
    };

    this.undoAwaiting = function () {
        ctrl.order.sit_portal = ctrl.sit_old;
        ctrl.sit_old = null
    };

    this.shipDateChanged = function () {
        ctrl.makeSugestion = false;
    };

    this.dateChanged = function (ev) {
        console.log('promiseDateChanged');
        console.log(ev);
        var sugestion = null;
        if (ctrl.order.PromiseDate && ctrl.order.RouteDays) {
            sugestion = ctrl.order.PromiseDate.addDays(ctrl.order.RouteDays);
        }
        else {

        }
        if (!ctrl.order.ShipDateDescr || ctrl.makeSugestion) {
            ctrl.order.ShipDateDescr = this.formatDate(sugestion);
            ctrl.makeSugestion = true;
        }
    };

    this.formatDate = function (date) {
        if (!date) {
            return '';
        }
        //var month = date.getUTCMonth() + 1;
        //var str = ' '; //JRM: Evita que o Excel transforme em data
        //str += this.getMonthName(month);
        //str += '/';
        var str = '';
        str += $filter('date')(date, 'MMM/dd/yyyy', 'utc'); // for conversion to string
        return str;
    };

    this.convertoToLibras = function (peso) {
        if (peso) {
            return peso * 2.20462;
        }
        else {
            return 0;
        }
    };

    Date.prototype.addDays = function (days) {
        this.setDate(this.getDate() + days);
        return this;
    };

}

SdOrderAcceptHeaderCtrl.$inject = ['$filter', 'TranslationService', 'StoreService'];

seedWebApp.component('sdOrderAcceptHeader', {
    controller: SdOrderAcceptHeaderCtrl,
    bindings: {
        order: '<',
    },
    templateUrl: '/SPA/Orders/sd-order-accept-header.html' + seedWebApp.buildVersion
});